<template>
  <layout>
    <h4>Edit template</h4>
    <resource-form
      :id="$route.params.id"
      @saved="returnBack"
      @cancelled="returnBack"
    />
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import ResourceForm from './Form.vue';

const resourceBase = 'pages-generator';

export default {
  name: 'PagesEdit',

  components: {
    Layout,
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({name: `${resourceBase}.index`});
    },
  },

};
</script>
